import axios from "../../axios";
import { Commit, Dispatch } from 'vuex'
import router from "@/router";

const baseURL = "/group_members";

export default ({
    namespaced: true,
    state : {
        group_members: [],
        group_members_archived: [],
        item:{},
        status: 'loading'
    },
    actions : {
        async index({commit}: {commit: Commit}, payload={}){
            commit('SET_STATUS', 'loading')
            const { data } = await axios.get(`${baseURL}`, {params: {...payload}});
            commit('SET_ITEMS', data)
            commit('SET_STATUS', 'completed')
            return data
        },
        
        async store({dispatch}: {dispatch: Dispatch}, payload={}){
            const { data } = await axios.post(`${baseURL}`, payload);
            router.push('/groups')
            return data
        },

        async update({dispatch}: {dispatch: Dispatch}, payload={id: ''}){
            const { data } = await axios.put(`${baseURL}/${payload.id}`, payload);
            return data
        },

        async show({commit}: {commit: Commit}, id=""){
            const { data } = await axios.get(`${baseURL}/${id}`);
            return data
        },

        async destroy({dispatch}: {dispatch: Dispatch}, id=""){
            const { data } = await axios.delete(`${baseURL}/${id}`);
            dispatch('index')
            return data
        },

        async archive({dispatch}: {dispatch: Dispatch}, id=""){
            const { data } = await axios.delete(`${baseURL}/${id}`);
            router.push('/groups')
            return data
        },

        async restore({dispatch}: {dispatch: Dispatch}, id=""){
            const { data } = await axios.post(`${baseURL}/${id}/restore`);
            router.push('/groups')
            return data
        },

        async members({commit}: {commit: Commit}, payload={id:""}){
            commit('SET_STATUS', 'loading')
            const { data } = await axios.get(`${baseURL}/${payload.id}/members`, {params: {...payload}});
            commit('SET_ITEMS', data)
            commit('SET_STATUS', 'completed')

        },

    },
    mutations:{
        SET_ITEMS(state:any, data: any){
            state.group_members = data.data;
        },
        SET_ITEMS_ARCHIVED(state:any, data: any){
            state.group_members_archived = data.data;
        },
        SET_STATUS(state: any, payload: string){
            state.status = payload;
        },
    },
    getters:{
        items(state: any){
            return state.group_members;
        },
        items_archived(state: any){
            return state.group_members_archived;
        },
        status(state: any){
            return state.status;
        }
    }
});




